import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import DashboardMockup from "@/components/landing/DashboardMockup";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* form side */}
      <div className="flex flex-col px-6 sm:px-10 lg:px-16 py-8">
        <Logo />
        <div className="flex-1 flex items-center">
          <div className="w-full max-w-sm mx-auto">
            <h1 className="font-display text-3xl font-bold tracking-tight text-foreground">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
          </div>
        </div>
        <p className="text-xs text-muted-foreground">
          <Link to="/" className="hover:text-foreground transition-colors">← Back to home</Link>
        </p>
      </div>

      {/* visual side */}
      <div className="hidden lg:flex relative bg-primary items-center justify-center overflow-hidden p-12">
        <div className="absolute inset-0 pitso-grid-bg opacity-10" />
        <div className="relative max-w-lg">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-accent mb-3">Meet. Connect. Engage.</p>
          <h2 className="font-display text-3xl font-bold tracking-tight text-white mb-8 leading-tight">
            The command centre for every conversation around your event.
          </h2>
          <DashboardMockup />
        </div>
      </div>
    </div>
  );
}
